<template>
  <div class="knowledge-page">
    <div class="knowledge-container">
      <div class="knowledge-header">
        <h1>学习资料</h1>
        <div class="search-container">
          <div class="search-box">
            <input
              type="text"
              class="form-control"
              v-model="searchKeyword"
              placeholder="搜索书籍..."
              @keyup.enter="searchBooks"
            >
            <button class="btn btn-primary" @click="searchBooks">搜索</button>
          </div>
        </div>
      </div>

      <!-- 书籍卡片展示 -->
      <div class="books-grid">
        <div 
          v-for="book in books" 
          :key="book.id"
          class="book-card"
          @click="openEbook(book)"
        >
          <div class="book-cover">
            <img :src="book.cover" :alt="book.title">
          </div>
          <div class="book-info">
            <h3 class="book-title">{{ book.title }}</h3>
            <p class="book-description">{{ book.description }}</p>
          </div>
        </div>
      </div>

      <!-- 电子书模态框 -->
      <div class="ebook-modal" v-if="showEbook">
        <div class="ebook-container">
          <div class="ebook-header">
            <h2>{{ currentBook.title }}</h2>
            <div class="header-controls">
              <button class="close-btn" @click="closeEbook">×</button>
            </div>
          </div>
          <div class="ebook-content">
            <!-- PDF 嵌入模式 -->
            <div v-if="currentBook && currentBook.isPdf" class="pdf-viewer">
              <!-- PDF 选择器 -->
              <div v-if="currentBook.pdfList && currentBook.pdfList.length > 0" class="pdf-selector">
                <button 
                  v-for="(pdf, index) in currentBook.pdfList" 
                  :key="index"
                  class="pdf-tab"
                  :class="{ active: currentPdfIndex === index }"
                  @click="selectPdf(index)"
                >
                  {{ pdf.name }}
                </button>
              </div>
              <iframe :src="currentPdfUrl" width="100%" height="100%" frameborder="0"></iframe>
            </div>
          </div>
          <div class="ebook-navigation" v-if="currentBook && !currentBook.isPdf">
            <button 
              class="nav-btn" 
              :disabled="currentPage === 0"
              @click="prevPage"
            >
              上一页
            </button>
            <span class="page-info">{{ currentPage + 1 }} / {{ currentBook.pages.length }}</span>
            <button 
              class="nav-btn" 
              :disabled="currentPage === currentBook.pages.length - 1"
              @click="nextPage"
            >
              下一页
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKnowledgebaseList, getKnowledgebaseDetail } from '@/api/droneApi';
import { baseURL } from '@/api/axiosConfig';

export default {
  name: 'KnowledgePage',
  data() {
    return {
      searchKeyword: '',
      showEbook: false,
      currentBook: null,
      currentPage: 0,
      currentPdfIndex: 0,
      currentPdfUrl: '',
      // 书籍数据
      books: [],
      // 分页数据
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      loading: false
    }
  },
  methods: {
    // 获取学习资料列表
    async fetchKnowledgebaseList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        
        if (this.searchKeyword) {
          params.name = this.searchKeyword
        }
        
        const res = await getKnowledgebaseList(params)
        
        if (res.data.code === 200 && res.data.data) {
          const data = res.data.data
          
          // 更新分页数据
          this.total = data.total
          this.pages = data.pages
          
          // 转换接口返回的数据格式
          this.books = data.list.map(item => ({
            id: item.id,
            title: item.name,
            description: item.brief,
            cover: baseURL + item.imgurl,
            isPdf: true,
            pdfUrl: baseURL + item.pdfurl
          }))
        }
      } catch (error) {
        console.error('获取学习资料列表失败:', error)
        alert('获取学习资料列表失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索书籍
    searchBooks() {
      this.pageNum = 1
      this.fetchKnowledgebaseList()
    },

    // 打开电子书
    // 修改 openEbook 方法
async openEbook(book) {
  try {
    // 从接口获取详细信息
    const res = await getKnowledgebaseDetail(book.id)
    
    if (res.data.code === 200 && res.data.data) {
      const detailData = res.data.data
      
      // 构建完整的书籍对象
      const bookData = {
        id: detailData.id,
        title: detailData.name,
        description: detailData.brief,
        cover: baseURL + detailData.imgurl,
        isPdf: true,
        pdfUrl: baseURL + detailData.pdfurl
      }
      
      // 在新窗口中打开 PDF
      window.open(bookData.pdfUrl, '_blank')
    } else {
      alert('获取书籍详情失败')
    }
  } catch (error) {
    console.error('获取书籍详情失败:', error)
    alert('获取书籍详情失败，请稍后重试')
  }
},
    // 选择 PDF
    selectPdf(index) {
      this.currentPdfIndex = index
      this.currentPdfUrl = this.currentBook.pdfList[index].url
    },
    
    // 关闭电子书
    closeEbook() {
      this.showEbook = false
      this.currentBook = null
      this.currentPage = 0
      this.currentPdfIndex = 0
      this.currentPdfUrl = ''
    },

    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--
      }
    },

    // 下一页
    nextPage() {
      if (this.currentBook && this.currentPage < this.currentBook.pages.length - 1) {
        this.currentPage++
      }
    }
  },
  mounted() {
    this.fetchKnowledgebaseList()
  }
}
</script>

<style scoped>
.knowledge-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: #f5f7fa;
  min-height: 100vh;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.knowledge-container {
  min-height: 80vh;
}

.knowledge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
}

.knowledge-header h1 {
  font-size: 32px;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.search-container {
  flex: 1;
  max-width: 400px;
}

.search-box {
  display: flex;
  gap: 10px;
  width: 100%;
}

.search-box input {
  flex: 1;
  min-width: 200px;
  padding: 12px 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s;
}

.search-box input:focus {
  outline: none;
  border-color: #159895;
  box-shadow: 0 0 0 3px rgba(21, 152, 149, 0.1);
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #1a5f7a 0%, #159895 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(21, 152, 149, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #159895 0%, #1a5f7a 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(21, 152, 149, 0.4);
}

/* 书籍卡片网格 */
.books-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

/* 书籍卡片 */
.book-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  padding: 20px;
  gap: 20px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.book-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
}

.book-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #1a5f7a 0%, #159895 100%);
}

/* 书籍封面 */
.book-cover {
  flex: 0 0 120px;
  height: 160px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.book-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.book-card:hover .book-cover img {
  transform: scale(1.05);
}

/* 书籍信息 */
.book-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.book-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 10px 0;
  line-height: 1.3;
}

.book-description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

/* 电子书模态框 */
.ebook-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.ebook-container {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.ebook-header {
  background: linear-gradient(135deg, #1a5f7a 0%, #159895 100%);
  color: white;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.ebook-header h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.header-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 32px;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg);
}

.ebook-content {
  flex: 1;
  padding: 40px;
  overflow: hidden;
  position: relative;
  background: #f8f9fa;
  perspective: 2000px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf-viewer iframe {
  width: 100%;
  height: calc(95vh - 140px);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* PDF 选择器 */
.pdf-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.pdf-tab {
  padding: 8px 20px;
  border: 2px solid #159895;
  border-radius: 20px;
  background: white;
  color: #159895;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.pdf-tab:hover {
  background: rgba(21, 152, 149, 0.1);
}

.pdf-tab.active {
  background: linear-gradient(135deg, #1a5f7a 0%, #159895 100%);
  color: white;
  border-color: #159895;
}

.book-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.book {
  position: relative;
  width: 100%;
  max-width: 600px;
  height: 500px;
  transform-style: preserve-3d;
  transition: all 0.5s ease;
}

.book.double {
  max-width: 900px;
}

.book-spine {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(90deg, #1a5f7a 0%, #159895 100%);
  transform: translateZ(-10px);
  box-shadow: inset 2px 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px 0 0 4px;
}

.book.double .book-spine {
  left: 50%;
  transform: translateX(-50%) translateZ(-10px);
  border-radius: 4px;
}

.book-pages {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
}

.book-page {
  position: absolute;
  top: 0;
  left: 20px;
  width: calc(100% - 20px);
  height: 100%;
  transform-style: preserve-3d;
  transform-origin: left center;
  transition: transform 0.8s cubic-bezier(0.645, 0.045, 0.355, 1);
  cursor: pointer;
}

.book-page.current {
  transform: rotateY(0deg);
}

.book-page.flipped {
  transform: rotateY(-180deg);
}

/* 双页模式样式 */
.book.double .book-pages {
  width: 100%;
  height: 100%;
}

.double-page-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.double-page {
  display: flex;
  width: 100%;
  height: 100%;
  gap: 2px;
}

.page {
  flex: 1;
  height: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  padding: 30px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  transform: scale(1.01);
}

.page:active {
  transform: scale(0.99);
}

.left-page {
  border-radius: 8px 0 0 8px;
  border-right: 1px solid #e0e0e0;
}

.right-page {
  border-radius: 0 8px 8px 0;
  border-left: 1px solid #e0e0e0;
}

.page-content {
  height: 100%;
  overflow-y: auto;
}

.page-content::-webkit-scrollbar {
  width: 6px;
}

.page-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.page-content::-webkit-scrollbar-thumb {
  background: #159895;
  border-radius: 3px;
}

.page-content::-webkit-scrollbar-thumb:hover {
  background: #1a5f7a;
}

.page-front,
.page-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background: white;
  border-radius: 0 8px 8px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  padding: 30px;
}

.page-front {
  z-index: 2;
}

.page-back {
  transform: rotateY(180deg);
  z-index: 1;
}

.page-content {
  height: 100%;
  overflow-y: auto;
}

.page-content::-webkit-scrollbar {
  width: 6px;
}

.page-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.page-content::-webkit-scrollbar-thumb {
  background: #159895;
  border-radius: 3px;
}

.page-content::-webkit-scrollbar-thumb:hover {
  background: #1a5f7a;
}

.ebook-navigation {
  background: white;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e0e0e0;
}

.nav-btn {
  padding: 10px 20px;
  border: 1px solid #159895;
  border-radius: 6px;
  background: white;
  color: #159895;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.nav-btn:hover:not(:disabled) {
  background: #159895;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 152, 149, 0.3);
}

.nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* 电子书内容样式 */
.page-content h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #159895;
}

.page-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 10px 0;
}

.page-content p {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin: 0 0 15px 0;
}

.page-content ul {
  margin: 0 0 15px 0;
  padding-left: 20px;
}

.page-content li {
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  margin-bottom: 8px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .books-grid {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }

  .ebook-container {
    max-width: 800px;
  }
}

@media (max-width: 768px) {
  .knowledge-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-container {
    width: 100%;
    max-width: none;
  }

  .books-grid {
    grid-template-columns: 1fr;
  }

  .book-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .book-cover {
    flex: 0 0 150px;
    height: 200px;
  }

  .ebook-container {
    margin: 10px;
    max-height: 95vh;
  }

  .ebook-content {
    padding: 20px;
  }

  .book {
    max-width: 100%;
    height: 400px;
  }

  .book.double {
    max-width: 100%;
  }

  .book-page {
    left: 10px;
    width: calc(100% - 10px);
  }

  .book.double .book-page {
    left: 0;
    width: 50%;
  }

  .page-front,
  .page-back {
    padding: 20px;
  }

  .ebook-header h2 {
    font-size: 20px;
  }

  .ebook-navigation {
    padding: 15px 20px;
  }
}
</style>
